// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "./I18n.res.js";
import * as React from "react";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

let defaultStyle = {
  backgroundColor: "inherit",
  border: "none",
  cursor: "inherit",
  fontFamily: "inherit",
  minHeight: "56px",
  minWidth: "112px",
  resize: "none"
};

function TextArea(props) {
  let value = props.value;
  let style = props.style;
  let __readOnly = props.readOnly;
  let __placeholder = props.placeholder;
  let areaRef = props.areaRef;
  let placeholder = __placeholder !== undefined ? __placeholder : I18n.t("Enter text...");
  let readOnly = __readOnly !== undefined ? __readOnly : false;
  let domRef = Stdlib_Option.getOr(areaRef, React.useRef(null));
  let onHeightChange = React.useCallback(element => {
    let elementStyleDict = element["style"];
    Stdlib_Option.map(elementStyleDict, dict => {
      dict["overflow"] = "hidden";
    });
    Stdlib_Option.map(elementStyleDict, dict => {
      dict["height"] = "auto";
    });
    let offsetHeight = element.offsetHeight | 0;
    let scrollHeight = element.scrollHeight;
    let clientHeight = element.clientHeight;
    let unsafeHeight = (scrollHeight + (offsetHeight - clientHeight | 0) | 0).toString() + `px`;
    Stdlib_Option.map(elementStyleDict, dict => {
      dict["height"] = unsafeHeight;
    });
    Stdlib_Option.map(elementStyleDict, dict => {
      dict["overflow"] = "auto";
    });
  }, []);
  React.useLayoutEffect(() => {
    let area = domRef.current;
    if (!(area == null)) {
      onHeightChange(area);
    }
  }, [
    onHeightChange,
    areaRef,
    value
  ]);
  let match = Stdlib_Option.isSome(value) ? [
      undefined,
      value
    ] : [
      value,
      undefined
    ];
  let props_aria$label = "TextArea";
  let props_placeholder = placeholder;
  let props_inputElementType = "textarea";
  let props_value = match[1];
  let props_defaultValue = match[0];
  let props_onChange = props.onChange;
  let props_onFocus = props.onFocus;
  let props_onBlur = props.onBlur;
  let props$1 = {
    "aria-label": props_aria$label,
    placeholder: props_placeholder,
    inputElementType: props_inputElementType,
    isReadOnly: readOnly,
    value: props_value,
    defaultValue: props_defaultValue,
    onChange: props_onChange,
    onFocus: props_onFocus,
    onBlur: props_onBlur
  };
  let match$1 = ReactAria.useTextField(props$1, domRef);
  let props$2 = ReactAria.mergeProps(match$1.inputProps, props.ariaProps);
  let combinedStyle = style !== undefined ? Object.assign({}, defaultStyle, style) : defaultStyle;
  let newrecord = {...props$2};
  return JsxRuntime.jsx("textarea", (newrecord.style = combinedStyle, newrecord.ref = Primitive_option.some(domRef), newrecord));
}

let make = React.memo(TextArea);

export {
  make,
}
/* make Not a pure module */
